/**
 * @generated SignedSource<<be2139ad8cbe2339f97a725adc6e64be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BadgeKind = "emoji" | "icon" | "upload" | "%future added value";
export type ChatChannelVisibility = "private" | "public" | "%future added value";
export type ProductAppKind = "chat_channel" | "collection" | "content" | "curriculum" | "dashboard" | "events" | "group_directory" | "link" | "member_directory" | "members" | "nav_folder" | "organization_events" | "organization_members" | "posts" | "product_link" | "resources" | "slack" | "%future added value";
export type ProductAppStatus = "active" | "inactive" | "%future added value";
export type CreateChatChannelAppInput = {
  addMemberGroupIds?: ReadonlyArray<string> | null;
  addUserIds?: ReadonlyArray<string> | null;
  app: CreateAppInput;
  botIds?: ReadonlyArray<string> | null;
  visibility: ChatChannelVisibility;
};
export type CreateAppInput = {
  badge: BadgeInput;
  customAppDescription?: string | null;
  customAppTitle: string;
  navFolderId?: string | null;
  navSectionId?: string | null;
  ordering?: number | null;
  organizationId: string;
  productId?: string | null;
  showOnDashboard?: boolean | null;
};
export type BadgeInput = {
  assetId?: string | null;
  color?: string | null;
  emoji?: string | null;
  icon?: string | null;
  kind: BadgeKind;
  mediaUrl?: string | null;
};
export type ChatChannelSettingsForm_CreateMutation$variables = {
  input: CreateChatChannelAppInput;
  isOrgTopLevel: boolean;
};
export type ChatChannelSettingsForm_CreateMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly app: {
        readonly badge: {
          readonly " $fragmentSpreads": FragmentRefs<"BadgeFragment">;
        };
        readonly chatChannel: {
          readonly externalChannelId: string;
        } | null;
        readonly collection: {
          readonly id: string;
        } | null;
        readonly contentUsage: {
          readonly id: string;
        } | null;
        readonly customAppDescription: string | null;
        readonly customAppTitle: string | null;
        readonly customAppUrl: string | null;
        readonly feed: {
          readonly id: string;
          readonly name: string;
          readonly viewerPermissions: ReadonlyArray<string>;
          readonly " $fragmentSpreads": FragmentRefs<"usePermissionsFragment">;
        } | null;
        readonly forYouDashboard: {
          readonly id: string;
        } | null;
        readonly id: string;
        readonly kind: ProductAppKind;
        readonly linkProduct: {
          readonly slug: string;
        } | null;
        readonly navSection: {
          readonly " $fragmentSpreads": FragmentRefs<"AppsSidebarList_NavSectionFragment">;
        } | null;
        readonly ordering: number;
        readonly product: {
          readonly name: string;
          readonly slug: string;
          readonly " $fragmentSpreads": FragmentRefs<"appLevelContextFragment" | "usePermissionsFragment">;
        } | null;
        readonly productApps: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly chatChannel: {
                readonly externalChannelId: string;
              } | null;
              readonly id: string;
            };
          }>;
        } | null;
        readonly showOnDashboard: boolean;
        readonly status: ProductAppStatus;
        readonly " $fragmentSpreads": FragmentRefs<"AppSidebarItemFragment" | "AppUtils_getLocationFragment" | "ChatChannelSettingsModalButtonFragment" | "ChatChannelSideBarItemFragment" | "CollectionAppSettingsButtonFragment" | "ContentAppSettingsButtonFragment" | "DashboardAppSettingsButtonFragment" | "EventsAppSettingsButtonFragment" | "FeedAppSettingsButtonFragment" | "GenericAppSettingsButtonFragment" | "LinkAppSettingsButtonFragment" | "MembersAppSettingsButtonFragment" | "NavFolderSettingsDropdownFragment">;
      } | null;
      readonly id: string;
      readonly isAutomaticallyJoined: boolean;
      readonly organization: {
        readonly " $fragmentSpreads": FragmentRefs<"AppsSidebarList_OrganizationFragment" | "StreamChatContext_ChannelsFragment">;
      };
      readonly product: {
        readonly chatChannels: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
            };
          }>;
        };
        readonly slug: string;
        readonly " $fragmentSpreads": FragmentRefs<"AppsSidebarList_ProductFragment" | "MyExperiencesListItemFragment">;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"ChatChannelHeaderFragment">;
    } | null;
  };
};
export type ChatChannelSettingsForm_CreateMutation = {
  response: ChatChannelSettingsForm_CreateMutation$data;
  variables: ChatChannelSettingsForm_CreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isOrgTopLevel"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAutomaticallyJoined",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customAppTitle",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customAppDescription",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showOnDashboard",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordering",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalChannelId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "ChatChannel",
  "kind": "LinkedField",
  "name": "chatChannel",
  "plural": false,
  "selections": [
    (v9/*: any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customAppUrl",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v15 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "usePermissionsFragment"
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v17 = [
  (v2/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "Collection",
  "kind": "LinkedField",
  "name": "collection",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "ContentUsage",
  "kind": "LinkedField",
  "name": "contentUsage",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v20 = [
  (v16/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "linkProduct",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Dashboard",
  "kind": "LinkedField",
  "name": "forYouDashboard",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "ChatChannelNodeConnection",
  "kind": "LinkedField",
  "name": "chatChannels",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatChannelNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ChatChannel",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v17/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v26 = [
  (v14/*: any*/)
],
v27 = {
  "alias": "nonNullProductId",
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v29 = {
  "alias": "nonNullProductId",
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v30 = [
  (v29/*: any*/),
  (v14/*: any*/),
  (v28/*: any*/)
],
v31 = {
  "alias": "nullableProductId",
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v32 = [
  (v31/*: any*/),
  (v14/*: any*/),
  (v28/*: any*/)
],
v33 = {
  "alias": "nullableProductIdString",
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v34 = {
  "kind": "InlineFragment",
  "selections": [
    (v25/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v26/*: any*/),
      "type": "Organization",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v27/*: any*/),
        (v14/*: any*/),
        (v28/*: any*/)
      ],
      "type": "Product",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v30/*: any*/),
      "type": "Event",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v32/*: any*/),
      "type": "Comment",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v32/*: any*/),
      "type": "Feed",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v32/*: any*/),
      "type": "Post",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v33/*: any*/),
        (v14/*: any*/),
        (v28/*: any*/)
      ],
      "type": "ContentUsage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v32/*: any*/),
      "type": "ChatChannel",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v32/*: any*/),
      "type": "Dashboard",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v30/*: any*/),
      "type": "AssignmentSubmission",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v26/*: any*/),
      "type": "PathwayGroup",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v26/*: any*/),
      "type": "BrainSearch",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationId",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "Badge",
  "kind": "LinkedField",
  "name": "badge",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emoji",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mediaUrl",
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v38 = [
  (v29/*: any*/),
  (v28/*: any*/)
],
v39 = [
  (v31/*: any*/),
  (v28/*: any*/)
],
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "Feed",
  "kind": "LinkedField",
  "name": "feed",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v25/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v27/*: any*/),
            (v28/*: any*/)
          ],
          "type": "Product",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v38/*: any*/),
          "type": "Event",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v39/*: any*/),
          "type": "Comment",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v39/*: any*/),
          "type": "Feed",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v39/*: any*/),
          "type": "Post",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v33/*: any*/),
            (v28/*: any*/)
          ],
          "type": "ContentUsage",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v39/*: any*/),
          "type": "ChatChannel",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v39/*: any*/),
          "type": "Dashboard",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v38/*: any*/),
          "type": "AssignmentSubmission",
          "abstractKey": null
        }
      ],
      "type": "Node",
      "abstractKey": "__isNode"
    }
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v42 = {
  "alias": "connectedApps",
  "args": [
    {
      "kind": "Literal",
      "name": "includeNested",
      "value": true
    }
  ],
  "concreteType": "ProductAppNodeConnection",
  "kind": "LinkedField",
  "name": "productApps",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductAppNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductApp",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v11/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "productApps(includeNested:true)"
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductMembership",
  "kind": "LinkedField",
  "name": "viewerMembership",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "linkProduct",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductAppNodeConnection",
  "kind": "LinkedField",
  "name": "productApps",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductAppNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductApp",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ChatChannel",
              "kind": "LinkedField",
              "name": "chatChannel",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                (v2/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v45/*: any*/)
  ],
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "navSectionId",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    (v13/*: any*/),
    (v34/*: any*/),
    (v2/*: any*/),
    (v41/*: any*/),
    (v42/*: any*/),
    (v43/*: any*/)
  ],
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "ChatChannel",
  "kind": "LinkedField",
  "name": "chatChannel",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v9/*: any*/),
    (v34/*: any*/),
    (v35/*: any*/),
    (v36/*: any*/)
  ],
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfoObjectType",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v53 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProductAppNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductApp",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v4/*: any*/),
          (v40/*: any*/),
          (v49/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v44/*: any*/),
          (v46/*: any*/),
          (v22/*: any*/),
          (v7/*: any*/),
          (v35/*: any*/),
          (v37/*: any*/),
          (v47/*: any*/),
          (v36/*: any*/),
          (v48/*: any*/),
          (v50/*: any*/),
          (v25/*: any*/)
        ],
        "storageKey": null
      },
      (v51/*: any*/)
    ],
    "storageKey": null
  },
  (v52/*: any*/)
],
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductAppNodeConnection",
  "kind": "LinkedField",
  "name": "apps",
  "plural": false,
  "selections": (v53/*: any*/),
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v56 = [
  (v55/*: any*/),
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatChannelSettingsForm_CreateMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "CreateChatChannelAppResponse",
        "kind": "LinkedField",
        "name": "createChatChannelApp",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChatChannel",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductApp",
                "kind": "LinkedField",
                "name": "app",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Badge",
                    "kind": "LinkedField",
                    "name": "badge",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "BadgeFragment"
                      }
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Feed",
                    "kind": "LinkedField",
                    "name": "feed",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Product",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v13/*: any*/),
                      (v15/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "appLevelContextFragment"
                      }
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductAppNodeConnection",
                    "kind": "LinkedField",
                    "name": "productApps",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductAppNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductApp",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v22/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AppSidebarItemFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ContentAppSettingsButtonFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "LinkAppSettingsButtonFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FeedAppSettingsButtonFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "GenericAppSettingsButtonFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CollectionAppSettingsButtonFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ChatChannelSettingsModalButtonFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ChatChannelSideBarItemFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "NavFolderSettingsDropdownFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EventsAppSettingsButtonFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MembersAppSettingsButtonFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DashboardAppSettingsButtonFragment"
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "AppUtils_getLocationFragment",
                    "selections": [
                      (v2/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "product",
                        "plural": false,
                        "selections": (v20/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Feed",
                        "kind": "LinkedField",
                        "name": "feed",
                        "plural": false,
                        "selections": (v17/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChatChannel",
                        "kind": "LinkedField",
                        "name": "chatChannel",
                        "plural": false,
                        "selections": (v17/*: any*/),
                        "storageKey": null
                      },
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v21/*: any*/)
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NavSection",
                    "kind": "LinkedField",
                    "name": "navSection",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "AppsSidebarList_NavSectionFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MyExperiencesListItemFragment"
                  },
                  (v23/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AppsSidebarList_ProductFragment"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  {
                    "condition": "isOrgTopLevel",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "AppsSidebarList_OrganizationFragment"
                      }
                    ]
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "StreamChatContext_ChannelsFragment"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ChatChannelHeaderFragment"
              }
            ],
            "storageKey": null
          },
          (v24/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChatChannelSettingsForm_CreateMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "CreateChatChannelAppResponse",
        "kind": "LinkedField",
        "name": "createChatChannelApp",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChatChannel",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductApp",
                "kind": "LinkedField",
                "name": "app",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChatChannel",
                    "kind": "LinkedField",
                    "name": "chatChannel",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v2/*: any*/),
                      (v34/*: any*/),
                      (v35/*: any*/),
                      (v36/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v37/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v40/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Product",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v13/*: any*/),
                      (v34/*: any*/),
                      (v2/*: any*/),
                      (v41/*: any*/),
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v44/*: any*/),
                  (v46/*: any*/),
                  (v22/*: any*/),
                  (v35/*: any*/),
                  (v47/*: any*/),
                  (v36/*: any*/),
                  (v48/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NavSection",
                    "kind": "LinkedField",
                    "name": "navSection",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v54/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "filters": null,
                        "handle": "connection",
                        "key": "AppsSidebarList_NavSectionFragment__apps",
                        "kind": "LinkedHandle",
                        "name": "apps"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v2/*: any*/),
                  (v13/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductMembership",
                    "kind": "LinkedField",
                    "name": "viewerMembership",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "organizationMembershipId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Dashboard",
                        "kind": "LinkedField",
                        "name": "forYouDashboard",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductApp",
                            "kind": "LinkedField",
                            "name": "app",
                            "plural": false,
                            "selections": (v17/*: any*/),
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v37/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "waitingRoomEndsAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startDate",
                    "storageKey": null
                  },
                  (v41/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "adminCanLearnMode",
                    "storageKey": null
                  },
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductAppNodeConnection",
                    "kind": "LinkedField",
                    "name": "productApps",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductAppNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductApp",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v4/*: any*/),
                              (v40/*: any*/),
                              (v49/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v44/*: any*/),
                              (v46/*: any*/),
                              (v22/*: any*/),
                              (v7/*: any*/),
                              (v35/*: any*/),
                              (v37/*: any*/),
                              (v47/*: any*/),
                              (v36/*: any*/),
                              (v48/*: any*/),
                              (v50/*: any*/),
                              {
                                "alias": "folderApps",
                                "args": null,
                                "concreteType": "ProductAppNodeConnection",
                                "kind": "LinkedField",
                                "name": "productApps",
                                "plural": false,
                                "selections": (v53/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": "folderApps",
                                "args": null,
                                "filters": null,
                                "handle": "connection",
                                "key": "AppsSidebarList_ProductFragment__folderApps",
                                "kind": "LinkedHandle",
                                "name": "productApps"
                              },
                              (v25/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v51/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v52/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "connection",
                    "key": "AppsSidebarList_ProductFragment__productApps",
                    "kind": "LinkedHandle",
                    "name": "productApps"
                  },
                  (v34/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "includeProductLevel",
                        "value": true
                      },
                      {
                        "kind": "Literal",
                        "name": "kinds",
                        "value": [
                          "default",
                          "custom",
                          "direct_message"
                        ]
                      },
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": {
                          "direction": "DESC",
                          "field": "last_message_sent_at"
                        }
                      }
                    ],
                    "concreteType": "ChatChannelNodeConnection",
                    "kind": "LinkedField",
                    "name": "chatChannels",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChatChannelNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ChatChannel",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v47/*: any*/),
                              (v9/*: any*/),
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "appId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "product",
                                "plural": false,
                                "selections": [
                                  (v48/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductMembership",
                                    "kind": "LinkedField",
                                    "name": "viewerMembership",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v55/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductApp",
                                "kind": "LinkedField",
                                "name": "app",
                                "plural": false,
                                "selections": [
                                  (v48/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "chatChannels(includeProductLevel:true,kinds:[\"default\",\"custom\",\"direct_message\"],orderBy:{\"direction\":\"DESC\",\"field\":\"last_message_sent_at\"})"
                  },
                  (v2/*: any*/),
                  {
                    "condition": "isOrgTopLevel",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v54/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "filters": null,
                        "handle": "connection",
                        "key": "AppsSidebarList_OrganizationFragment__apps",
                        "kind": "LinkedHandle",
                        "name": "apps"
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              (v11/*: any*/),
              (v35/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 5
                  }
                ],
                "concreteType": "ChatChannelMemberNodeConnection",
                "kind": "LinkedField",
                "name": "chatChannelMembers",
                "plural": false,
                "selections": [
                  (v45/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChatChannelMemberNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChatChannelMember",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "firstName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fullName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "avatar",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isTest",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductMembership",
                            "kind": "LinkedField",
                            "name": "productMembership",
                            "plural": false,
                            "selections": (v56/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrganizationMembership",
                            "kind": "LinkedField",
                            "name": "organizationMembership",
                            "plural": false,
                            "selections": (v56/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "chatChannelMembers(first:5)"
              },
              (v34/*: any*/)
            ],
            "storageKey": null
          },
          (v24/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9d5794c503dfed0f0ced49feac523cfc",
    "id": null,
    "metadata": {},
    "name": "ChatChannelSettingsForm_CreateMutation",
    "operationKind": "mutation",
    "text": "mutation ChatChannelSettingsForm_CreateMutation(\n  $input: CreateChatChannelAppInput!\n  $isOrgTopLevel: Boolean!\n) {\n  response: createChatChannelApp(input: $input) {\n    node {\n      id\n      isAutomaticallyJoined\n      app {\n        id\n        customAppTitle\n        customAppDescription\n        showOnDashboard\n        status\n        ordering\n        chatChannel {\n          externalChannelId\n          id\n        }\n        badge {\n          ...BadgeFragment\n          id\n        }\n        kind\n        customAppUrl\n        feed {\n          id\n          name\n          viewerPermissions\n          ...usePermissionsFragment\n        }\n        product {\n          slug\n          name\n          ...usePermissionsFragment\n          ...appLevelContextFragment\n          id\n        }\n        collection {\n          id\n        }\n        contentUsage {\n          id\n        }\n        linkProduct {\n          slug\n          id\n        }\n        productApps {\n          edges {\n            node {\n              id\n              chatChannel {\n                externalChannelId\n                id\n              }\n            }\n          }\n        }\n        forYouDashboard {\n          id\n        }\n        ...AppSidebarItemFragment\n        ...ContentAppSettingsButtonFragment\n        ...LinkAppSettingsButtonFragment\n        ...FeedAppSettingsButtonFragment\n        ...GenericAppSettingsButtonFragment\n        ...CollectionAppSettingsButtonFragment\n        ...ChatChannelSettingsModalButtonFragment\n        ...ChatChannelSideBarItemFragment\n        ...NavFolderSettingsDropdownFragment\n        ...EventsAppSettingsButtonFragment\n        ...MembersAppSettingsButtonFragment\n        ...DashboardAppSettingsButtonFragment\n        ...AppUtils_getLocationFragment\n        navSection {\n          ...AppsSidebarList_NavSectionFragment\n          id\n        }\n      }\n      product {\n        slug\n        ...MyExperiencesListItemFragment\n        chatChannels {\n          edges {\n            node {\n              id\n            }\n          }\n        }\n        ...AppsSidebarList_ProductFragment\n        id\n      }\n      organization {\n        ...AppsSidebarList_OrganizationFragment @include(if: $isOrgTopLevel)\n        ...StreamChatContext_ChannelsFragment\n        id\n      }\n      ...ChatChannelHeaderFragment\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n\nfragment AppSidebarItemFragment on ProductApp {\n  kind\n  status\n  visibility\n  customAppTitle\n  badge {\n    ...BadgeFragment\n    id\n  }\n  product {\n    ...usePermissionsFragment\n    id\n  }\n  forYouDashboard {\n    id\n  }\n  ...RemoveAppButtonFragment\n  ...ToggleAppStatusButtonFragment\n}\n\nfragment AppUtils_getLocationFragment on ProductApp {\n  id\n  kind\n  customAppUrl\n  product {\n    slug\n    id\n  }\n  feed {\n    id\n  }\n  chatChannel {\n    id\n  }\n  collection {\n    id\n  }\n  contentUsage {\n    id\n  }\n  linkProduct {\n    slug\n    id\n  }\n}\n\nfragment AppsSidebarDragDropProvider_OrganizationFragment on Organization {\n  id\n  forYouDashboard {\n    app {\n      id\n    }\n    id\n  }\n}\n\nfragment AppsSidebarList_NavSectionFragment on NavSection {\n  id\n  apps {\n    edges {\n      node {\n        id\n        kind\n        customAppUrl\n        customAppTitle\n        feed {\n          id\n          name\n          viewerPermissions\n          ...usePermissionsFragment\n        }\n        product {\n          slug\n          name\n          ...usePermissionsFragment\n          ...appLevelContextFragment\n          id\n        }\n        collection {\n          id\n        }\n        contentUsage {\n          id\n        }\n        linkProduct {\n          slug\n          id\n        }\n        productApps {\n          edges {\n            node {\n              id\n              chatChannel {\n                externalChannelId\n                id\n              }\n            }\n          }\n        }\n        forYouDashboard {\n          id\n        }\n        ...AppSidebarItemFragment\n        ...ContentAppSettingsButtonFragment\n        ...LinkAppSettingsButtonFragment\n        ...FeedAppSettingsButtonFragment\n        ...GenericAppSettingsButtonFragment\n        ...CollectionAppSettingsButtonFragment\n        ...ChatChannelSettingsModalButtonFragment\n        ...ChatChannelSideBarItemFragment\n        ...NavFolderSettingsDropdownFragment\n        ...EventsAppSettingsButtonFragment\n        ...MembersAppSettingsButtonFragment\n        ...DashboardAppSettingsButtonFragment\n        ...AppUtils_getLocationFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AppsSidebarList_OrganizationFragment on Organization {\n  id\n  apps {\n    edges {\n      node {\n        id\n        kind\n        customAppUrl\n        customAppTitle\n        feed {\n          id\n          name\n          viewerPermissions\n          ...usePermissionsFragment\n        }\n        product {\n          slug\n          name\n          ...usePermissionsFragment\n          ...appLevelContextFragment\n          id\n        }\n        collection {\n          id\n        }\n        contentUsage {\n          id\n        }\n        linkProduct {\n          slug\n          id\n        }\n        productApps {\n          edges {\n            node {\n              id\n              chatChannel {\n                externalChannelId\n                id\n              }\n            }\n          }\n        }\n        forYouDashboard {\n          id\n        }\n        ...AppSidebarItemFragment\n        ...ContentAppSettingsButtonFragment\n        ...LinkAppSettingsButtonFragment\n        ...FeedAppSettingsButtonFragment\n        ...GenericAppSettingsButtonFragment\n        ...CollectionAppSettingsButtonFragment\n        ...ChatChannelSettingsModalButtonFragment\n        ...ChatChannelSideBarItemFragment\n        ...NavFolderSettingsDropdownFragment\n        ...EventsAppSettingsButtonFragment\n        ...MembersAppSettingsButtonFragment\n        ...DashboardAppSettingsButtonFragment\n        ...AppUtils_getLocationFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AppsSidebarList_ProductFragment on Product {\n  id\n  productApps {\n    edges {\n      node {\n        id\n        kind\n        customAppUrl\n        customAppTitle\n        feed {\n          id\n          name\n          viewerPermissions\n          ...usePermissionsFragment\n        }\n        product {\n          slug\n          name\n          ...usePermissionsFragment\n          ...appLevelContextFragment\n          id\n        }\n        collection {\n          id\n        }\n        contentUsage {\n          id\n        }\n        linkProduct {\n          slug\n          id\n        }\n        productApps {\n          edges {\n            node {\n              id\n              chatChannel {\n                externalChannelId\n                id\n              }\n            }\n          }\n        }\n        forYouDashboard {\n          id\n        }\n        ...AppSidebarItemFragment\n        ...ContentAppSettingsButtonFragment\n        ...LinkAppSettingsButtonFragment\n        ...FeedAppSettingsButtonFragment\n        ...GenericAppSettingsButtonFragment\n        ...CollectionAppSettingsButtonFragment\n        ...ChatChannelSettingsModalButtonFragment\n        ...ChatChannelSideBarItemFragment\n        ...NavFolderSettingsDropdownFragment\n        ...EventsAppSettingsButtonFragment\n        ...MembersAppSettingsButtonFragment\n        ...DashboardAppSettingsButtonFragment\n        ...AppUtils_getLocationFragment\n        folderApps: productApps {\n          edges {\n            node {\n              id\n              kind\n              customAppUrl\n              customAppTitle\n              feed {\n                id\n                name\n                viewerPermissions\n                ...usePermissionsFragment\n              }\n              product {\n                slug\n                name\n                ...usePermissionsFragment\n                ...appLevelContextFragment\n                id\n              }\n              collection {\n                id\n              }\n              contentUsage {\n                id\n              }\n              linkProduct {\n                slug\n                id\n              }\n              productApps {\n                edges {\n                  node {\n                    id\n                    chatChannel {\n                      externalChannelId\n                      id\n                    }\n                  }\n                }\n              }\n              forYouDashboard {\n                id\n              }\n              ...AppSidebarItemFragment\n              ...ContentAppSettingsButtonFragment\n              ...LinkAppSettingsButtonFragment\n              ...FeedAppSettingsButtonFragment\n              ...GenericAppSettingsButtonFragment\n              ...CollectionAppSettingsButtonFragment\n              ...ChatChannelSettingsModalButtonFragment\n              ...ChatChannelSideBarItemFragment\n              ...NavFolderSettingsDropdownFragment\n              ...EventsAppSettingsButtonFragment\n              ...MembersAppSettingsButtonFragment\n              ...DashboardAppSettingsButtonFragment\n              ...AppUtils_getLocationFragment\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment BadgeFragment on Badge {\n  kind\n  color\n  icon\n  emoji\n  mediaUrl\n}\n\nfragment ChatChannelBadgeFragment on ProductApp {\n  badge {\n    ...BadgeFragment\n    id\n  }\n  chatChannel {\n    visibility\n    id\n  }\n}\n\nfragment ChatChannelHeaderFragment on ChatChannel {\n  id\n  kind\n  visibility\n  product {\n    id\n    slug\n    name\n  }\n  app {\n    id\n    customAppTitle\n    customAppDescription\n    ...HeaderContentFragment\n    ...ChatChannelBadgeFragment\n    ...DeleteChatChannelAppButtonFragment\n  }\n  chatChannelMembers(first: 5) {\n    totalCount\n    edges {\n      node {\n        id\n        user {\n          id\n          firstName\n          lastName\n          ...ProfileAvatarFragment\n          ...ProfileListModalListItemFragment\n        }\n        productMembership {\n          role\n          id\n        }\n        organizationMembership {\n          role\n          id\n        }\n      }\n    }\n  }\n  ...usePermissionsFragment\n}\n\nfragment ChatChannelSettingsModalButtonFragment on ProductApp {\n  id\n  productId\n}\n\nfragment ChatChannelSideBarItemFragment on ProductApp {\n  id\n  customAppTitle\n  chatChannel {\n    id\n    externalChannelId\n    ...usePermissionsFragment\n  }\n  product {\n    slug\n    name\n    viewerMembership {\n      id\n    }\n    id\n  }\n  ...ChatChannelBadgeFragment\n  ...ChatChannelSettingsModalButtonFragment\n  ...DeleteChatChannelAppButtonFragment\n  ...AppUtils_getLocationFragment\n}\n\nfragment CollectionAppSettingsButtonFragment on ProductApp {\n  id\n  ...CollectionAppSettingsModalFragment\n}\n\nfragment CollectionAppSettingsModalFragment on ProductApp {\n  id\n}\n\nfragment ContentAppSettingsButtonFragment on ProductApp {\n  id\n  ...ContentAppSetupModalFragment\n}\n\nfragment ContentAppSetupModalFragment on ProductApp {\n  id\n}\n\nfragment DashboardAppSettingsButtonFragment on ProductApp {\n  id\n  ...DashboardAppSetupModalFragment\n}\n\nfragment DashboardAppSetupModalContentFragment on ProductApp {\n  id\n  forYouDashboard {\n    id\n  }\n}\n\nfragment DashboardAppSetupModalFragment on ProductApp {\n  customAppTitle\n  forYouDashboard {\n    id\n  }\n  ...DashboardAppSetupModalContentFragment\n}\n\nfragment DeleteChatChannelAppButtonFragment on ProductApp {\n  id\n  navSectionId\n  product {\n    id\n    slug\n  }\n  chatChannel {\n    id\n    organizationId\n  }\n}\n\nfragment DeleteNavFolderButtonFragment on ProductApp {\n  id\n  customAppTitle\n  productApps {\n    totalCount\n  }\n}\n\nfragment EventsAppSettingsButtonFragment on ProductApp {\n  id\n  ...EventsAppSetupModalFragment\n}\n\nfragment EventsAppSetupModalFragment on ProductApp {\n  id\n}\n\nfragment ExperienceAdminDropdownFragment on Product {\n  id\n  slug\n  type\n  name\n  adminCanLearnMode\n  ...LearnModeSwitchFragment\n  ...usePermissionsFragment\n}\n\nfragment FeedAppSettingsButtonFragment on ProductApp {\n  id\n  ...FeedAppSetupModalFragment\n}\n\nfragment FeedAppSetupModalFragment on ProductApp {\n  id\n}\n\nfragment GenericAppSettingsButtonFragment on ProductApp {\n  id\n  ...GenericAppSettingsModalFragment\n}\n\nfragment GenericAppSettingsModalFragment on ProductApp {\n  id\n  kind\n}\n\nfragment HeaderContentFragment on ProductApp {\n  id\n  kind\n  customAppTitle\n  badge {\n    ...BadgeFragment\n    id\n  }\n  product {\n    ...LearnModeSwitchFragment\n    id\n  }\n}\n\nfragment LearnModeSwitchFragment on Product {\n  id\n  name\n  status\n  viewerMembership {\n    id\n  }\n}\n\nfragment LeaveProductButtonFragment on Product {\n  name\n  slug\n  type\n  viewerMembership {\n    id\n    organizationMembershipId\n  }\n}\n\nfragment LinkAppSettingsButtonFragment on ProductApp {\n  id\n  ...LinkAppSetupModalFragment\n}\n\nfragment LinkAppSetupModalFragment on ProductApp {\n  id\n  kind\n}\n\nfragment MemberDirectoryAppSettingsModalFragment on ProductApp {\n  id\n  kind\n}\n\nfragment MembersAppSettingsButtonFragment on ProductApp {\n  id\n  kind\n  productId\n  ...MemberDirectoryAppSettingsModalFragment\n}\n\nfragment MyExperiencesListItemFragment on Product {\n  id\n  name\n  slug\n  status\n  viewerMembership {\n    id\n  }\n  organization {\n    ...AppsSidebarDragDropProvider_OrganizationFragment\n    id\n  }\n  ...ProductBadgeFragment\n  ...usePermissionsFragment\n  ...useIsWaitingRoomEnabledActiveProductFragment\n  ...ExperienceAdminDropdownFragment\n  ...LeaveProductButtonFragment\n  ...LearnModeSwitchFragment\n}\n\nfragment NavFolderSettingsButtonFragment on ProductApp {\n  id\n}\n\nfragment NavFolderSettingsDropdownFragment on ProductApp {\n  id\n  product {\n    ...usePermissionsFragment\n    id\n  }\n  ...NavFolderSettingsButtonFragment\n  ...DeleteNavFolderButtonFragment\n}\n\nfragment ProductBadgeFragment on Product {\n  id\n  badge {\n    ...BadgeFragment\n    id\n  }\n}\n\nfragment ProfileAvatarFragment on User {\n  id\n  fullName\n  avatar\n  isTest\n}\n\nfragment ProfileListModalListItemFragment on User {\n  id\n  firstName\n  lastName\n  fullName\n  ...ProfileAvatarFragment\n}\n\nfragment RemoveAppButtonFragment on ProductApp {\n  id\n  kind\n  customAppTitle\n  feed {\n    id\n    name\n  }\n  collection {\n    id\n  }\n  productId\n  organizationId\n  navSectionId\n}\n\nfragment StreamChatContext_ChannelsFragment on Organization {\n  chatChannels(kinds: [default, custom, direct_message], includeProductLevel: true, orderBy: {field: \"last_message_sent_at\", direction: DESC}) {\n    edges {\n      node {\n        id\n        productId\n        externalChannelId\n        kind\n        appId\n        product {\n          navSectionId\n          status\n          viewerMembership {\n            id\n            role\n          }\n          id\n        }\n        app {\n          navSectionId\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment ToggleAppStatusButtonFragment on ProductApp {\n  id\n  status\n  kind\n  product {\n    type\n    id\n  }\n}\n\nfragment appLevelContextFragment on Product {\n  id\n  name\n  slug\n  type\n  ...useConnectedProductAppsActiveProductFragment\n}\n\nfragment useConnectedProductAppsActiveProductFragment on Product {\n  connectedApps: productApps(includeNested: true) {\n    edges {\n      node {\n        id\n        kind\n      }\n    }\n  }\n}\n\nfragment useIsWaitingRoomEnabledActiveProductFragment on Product {\n  waitingRoomEndsAt\n  startDate\n  ...usePermissionsFragment\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "8b46daa792af7b16373db7d1e7db7126";

export default node;
